"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var CategoryAddView_1 = __importDefault(require("./CategoryAddView"));
var CategoryEditView_1 = __importDefault(require("./CategoryEditView"));
var CategoryListView_1 = __importDefault(require("./CategoryListView"));
var CategoriesPage = react_1.default.memo(function () { return react_1.default.createElement(react_router_dom_1.Routes, null,
    react_1.default.createElement(react_router_dom_1.Route, { path: "list", element: react_1.default.createElement(CategoryListView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "add", element: react_1.default.createElement(CategoryAddView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "edit/:id", element: react_1.default.createElement(CategoryEditView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "list", replace: true }) })); });
exports.default = CategoriesPage;
